import React from "react";

const ArrowRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 15.809 27.117">
      <g
        id="Icons_Arrows_Right"
        data-name="Icons / Arrows / Right"
        transform="translate(1.059 1.059)"
      >
        <path
          id="Path"
          d="M14,25,0,12.5,14,0"
          transform="translate(14 25) rotate(180)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="4.5"
        />
      </g>
    </svg>
  );
};

export default ArrowRight;
